<template>
  <div>
    <!-- 卡片试图 -->
    <el-card class="box-card" v-loading="loading">
      <!-- 用户列表区域 -->
      <el-table
        :data="tableData"
        stripe
        class="table"
        ref="table"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column
          :label="$t('channelList.label.channelName')"
          prop="channelName"
        ></el-table-column>
        <el-table-column :label="$t('channelList.label.api')" prop="apiName"></el-table-column>
        <el-table-column :label="$t('channelList.label.status')" prop="openStatus">
          <template slot-scope="{ row }">
            <el-switch
              style="display: block"
              v-model="row.openStatus > 0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-text="$t('channelList.status.open')"
              :inactive-text="$t('channelList.status.close')"
              @change="(val) => handleChangeStatus(row, 'status', val)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('channelList.label.attribute3')"
          prop="attribute3"
        ></el-table-column>
        <el-table-column :label="$t('channelList.label.attribute4')" prop="attribute4">
          <template slot-scope="{ row }">
            <el-input
              v-model="row.attribute4"
              size="small"
              style="width: 50px; text-align: center"
              @input="handleInput"
            />
            %
            <el-button
              type="primary"
              size="mini"
              @click="handleChangeStatus(row,'attribute4')"
            >{{$t('sysConfig.update')}}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--      <el-dialog-->
      <!--        :visible.sync="showKeysInfoFlag"-->
      <!--        :close-on-click-modal="false"-->
      <!--        width="30%">-->
      <!--        <el-form :model="merchantKeys" label-width="100px">-->
      <!--          <el-form-item :label="$t('clientmanage.addDialog.payPass')">-->
      <!--            <label>{{ merchantKeys.merchantKey }}</label>-->
      <!--          </el-form-item>-->
      <!--          <el-form-item :label="$t('clientmanage.addDialog.googleCode')">-->
      <!--            <label>{{ merchantKeys.secret }}</label>-->
      <!--          </el-form-item>-->
      <!--          <el-form-item :label="$t('clientmanage.addDialog.googleQrCode')">-->
      <!--            <img :src="merchantKeys.secretQr" alt width="150" height="150" />-->
      <!--          </el-form-item>-->
      <!--        </el-form>-->
      <!--      </el-dialog>-->
    </el-card>
  </div>
</template>

<script>
import merchantApi from '@/api/merchant';
import channel from '../../api/channel';

export default {
  name: 'ChannelSetting',
  data() {
    return {
      loading: false,
      tableData: [],
      openStatus: '',
      attribute4: ''
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    formatParams() {
      const _form = Object.keys(this.addClient).reduce((acc, key) => {
        if (!this.isAdd && ['payPass', 'userPass'].indexOf(key) > -1) {
          /**
           * 如果格式化参数为update ，则干掉passwd相关字段
           */
          return acc;
        }
        if (this.addClient[key] === 0 || this.addClient[key]) {
          acc[key] = this.addClient[key];
        }
        return acc;
      }, {});
      return {
        ..._form,
        roleId: this.roleId,
        merchantChannelIds: this.checkedChannels.length > 0 ? this.checkedChannels.join(',') : ''
      };
    },
    // 获取数据列表
    async getTableList() {
      const { data } = await channel.getThirdChannelList({ no: 1, size: 100, query: {} });
      console.log('卧槽这里没有执行。。。', data);
      if (data && +data.code === 200) {
        this.tableData = data.data.list;
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    // 更新状态
    async handleChangeStatus(row, type, val = '') {
      const params =
        type === 'status' ? { openStatus: Number(val) } : { attribute4: this.attribute4 };
      const { data } = await channel.updateThirdChannelList({ id: row.id, ...params });
      console.log('修改后端只阿瑟东发。。。。', data);
      if (data && +data.code === 200) {
        this.$message.success(data.message);
      } else {
        this.$message.error(this.$t('status.error'));
      }
      this.attribute4 = '';
      this.getTableList();
    },
    handleInput(val) {
      this.attribute4 = val;
    },
    async handleExport() {
      const { data } = await merchantApi.doExport({
        merchantName: this.searchQuery.merchantName
      });
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-List${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    async checkClient(merchantName) {
      const { data } = await this.$http.get(`/merchant/getMerchant/${merchantName}`);
      if (data && data.code === 200) {
        this.$store.commit('SET_CLIENTDATA', data.data);
        // 跳转详情页
        this.$router.push({ name: 'merchantdetails' });
      } else {
        return this.$message.error(data.msg);
      }
    },
    async showKeysInfo(row) {
      const { data } = await merchantApi.getSecretKeys({ merchantNo: row.merchantNo });
      console.log(data);
      if (data && data.code == 200) {
        this.merchantKeys = Object.assign({}, data.data);
        this.merchantKeys.secretQr = `data:image/png;base64,${data.data.secretQr}`;
        this.showKeysInfoFlag = true;
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    async resetpassword(row) {
      // 弹框询问用户是否重置密码
      const confirmResult = await this.$confirm(
        this.$t('accountmanager.hintmessage'),
        this.$t('btns.hint'),
        {
          confirmButtonText: this.$t('btns.confirm'),
          cancelButtonText: this.$t('btns.cancel'),
          type: 'warning'
        }
      ).catch((err) => err);
      // 用户确认删除 返回值为字符串 confirm
      // 用户取消删除 返回值为字符串 cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info(this.$t('btns.cancel'));
      }
      this.loading = true;
      const res = await this.$http.get('/merchant/restPayPassword?merchantId=' + row.merchantNo);
      this.loading = false;
      if (res.data.code != 200) {
        return this.$message.error(this.$t('btns.error'));
      }
      this.$message.success(this.$t('btns.success'));
      // 刷新数据列表
      this.getClient();
    },
    // 取消修改
    clearChange() {
      this.$message.warning('cancel');
      this.getClient();
    }
  }
};
</script>

<style scoped>
.box-card,
.table,
.pag {
  margin-top: 20px;
}

.el-col .el-button:nth-child(1),
.el-col .el-button:nth-child(2) {
  padding: 10px 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/channelSetting/index.vue